export default "__VITE_PUBLIC_ASSET__fd422797__"